export function prohibitInput(event: KeyboardEvent, prohibitedCharacters: string[]) {
  if (prohibitedCharacters.includes(event.key)) {
    event.preventDefault();
  }
}
